module.exports = __webpack_public_path__ + "static/media/yes-h-website.a65f8c4b.png";